import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {LoginService} from './../services/login/login.service';
import {ResponseValidator} from './../utils/response-validator';
import {Observable} from 'rxjs';
import {queryParamToObject} from './../utils/util';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
              private auth: LoginService) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<any> | any {
    if (this.auth.userData.authenticated || this.auth.checkAuthSession(true)) {
      if (this.auth.userData.careGivees && this.auth.userData.careGivees.length && !this.auth.activeMember) {
        return this.router.navigateByUrl('/select-user', {
          queryParams: queryParamToObject(),
          queryParamsHandling: 'merge'
        });
      }
      if (this.auth.activeMember) {
        Object.assign(this.auth.userData, {
          data: this.auth.activeMember,
          caregivee: this.auth.activeMember.type === 'caregivee'
        });
      }
      return true;
    }
    const availableAuth = this.auth.authenticateCookie();
    return availableAuth.subscribe(response => {
      if (new ResponseValidator(response, true).status) {
        if (!this.auth.processAuthResp(response.response.detail)) {
          this.auth.requestAuth(this.router, state);
          return false;
        }
        const url = state.url === '/' || state.url === '' ? '/' : state.url;
        return this.router.navigateByUrl(url);
      } else {
        this.auth.requestAuth(this.router, state);
        return false;
      }
    }, err => {
    });
  }


}
